// extracted by mini-css-extract-plugin
export default {"box":"event-organizer-section_box__L1faX"};